import { useContext } from 'react';
import useHttp from './useHttp';
import AuthContext from '../context/authContext';

const useRight = () => {
  const authCtx = useContext(AuthContext);
  const { isLoading, error, sendRequest, setError } = useHttp();

  const getRightStrings = async () => {
    try {
      const response = await sendRequest({
        url: `/api/v1/right/strings`,
        method: 'GET',
        headers: authCtx.getAuthHeaders(),
      });
      return response;
    } catch (err) {
      throw err;
    }
  };

  const getRightsTree = async () => {
    try {
      const response = await sendRequest({
        url: `/api/v1/right/tree`,
        method: 'GET',
        headers: authCtx.getAuthHeaders(),
      });
      return response;
    } catch (err) {
      throw err;
    }
  };

  return { isLoading, error, setError, getRightStrings, getRightsTree };
};

export default useRight;
